module.exports = __webpack_public_path__ + "img/diskette-2.f842dfa0.svg";